import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import { useStyles } from "../styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useOneParkAlias from "./useOneParkAlias";
import AppConfig from "AppConfig";

const BASE_URL = AppConfig.onePark?.baseUrl || "https://onepark.amano-one.com/";

const OneParkSettingsForm = ({
  entityID,
  entityType,
  settingValues,
  disabled,
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(true);

  const { alias, error, handleChange, handleBlur, isChecking } =
    useOneParkAlias(entityID, entityType, settingValues, disabled);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <Grid container className={classes.panelRoot}>
      <Accordion
        data-tag="onepark"
        expanded={expanded}
        TransitionProps={{ unmountOnExit: true }}
        className={classes.fullWidthAccordion}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={toggleExpanded}
        >
          <Typography className={classes.heading}>ONEpark</Typography>
          <Typography className={classes.secondaryHeading}></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={8} md={6} lg={6} xl={6}>
              <TextField
                data-testid="onepark-alias-input"
                id="onepark-alias"
                name="onepark-alias"
                label="ONEpark URL"
                variant="outlined"
                fullWidth
                value={alias}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled}
                error={!!error}
                helperText={error || ""}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {BASE_URL}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

OneParkSettingsForm.defaultProps = {
  disabled: false,
};

export default OneParkSettingsForm;
